import { Box, Container } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import GlobalSnackbarNotifier from '../../shared/components/ui-widgets/GlobalSnackbarNotifier'
import Footer from './Footer'
import ResponsiveMenuAppBar from '../../shared/layout/ReponsiveMenuAppBar'

const DashboardLayout: React.FC = () => {
  return (
    <Box sx={{ display: 'flex' }} flexDirection={'column'} minHeight={'100vh'}>
      <ResponsiveMenuAppBar/>
      <GlobalSnackbarNotifier/>
      <Box sx={{ p: 4 }}>
        <Container maxWidth={'lg'} sx={{ display: 'flex' }}>
          < Outlet/>
        </Container>
      </Box>
      <Box sx={{ flexGrow: 1 }}></Box>
      <Footer />
    </Box>
  )
}
export default DashboardLayout
